module.exports = __webpack_public_path__ + "img/Cart.a76aa952.png";